"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var get_or_1 = require("get-or");
var _1 = require(".");
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["HOURS"] = "h";
    TimeUnit["MILLI_SECONDS"] = "ms";
    TimeUnit["MINUTES"] = "m";
    TimeUnit["SECONDS"] = "s";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
var Time = /** @class */ (function (_super) {
    __extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.config = {
            optionalPartialConfig: {
                timeUnit: {
                    getter: get_or_1.stringOr,
                    decorators: function (unit) {
                        if (!unit) {
                            return TimeUnit.MILLI_SECONDS;
                        }
                        if (!_1.checkStringEnum(TimeUnit, unit)) {
                            throw new Error("Invalid time unit: " + unit);
                        }
                        return unit;
                    }
                }
            }
        };
        _this.timeInMillis = -1;
        _this.timeUnit = TimeUnit.MILLI_SECONDS;
        return _this;
    }
    return Time;
}(get_or_1.Transerializable));
exports.Time = Time;
//# sourceMappingURL=time.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-model/dist/common/time.js
 ** module id = 206
 ** module chunks = 0
 **/